export const organizationsQueryBase = {
	_limit: 999,
};

export const createEmptyOrganization = () => ({
	title: '',
	products: [],
});
